module.exports = __webpack_public_path__ + "static/img/honor5.c16be97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor5.jpg
// module id = Z/jA
// module chunks = 4